import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CircleCloseOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="m9.18 9.18 5.64 5.64M14.82 9.18l-5.64 5.64"
        stroke={color ? color : '#000'}
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 4.09c4.36 0 7.91 3.55 7.91 7.91s-3.55 7.91-7.91 7.91S4.09 16.36 4.09 12 7.64 4.09 12 4.09Zm0-1.6c-5.25 0-9.51 4.26-9.51 9.51s4.26 9.51 9.51 9.51 9.51-4.26 9.51-9.51S17.25 2.49 12 2.49Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CircleCloseOutlined
